import React from 'react';
import format from 'string-format';
import resx from '../../../utilities/resx';
import { RESX_LISTINGS } from '../../../Constants';
import { usePagingContext } from './PagingContext';
import Spinner from '../Spinner';

const ItemRange = ({ isLoading, loadingSize }) => {
    const { paging, setPaging } = usePagingContext();

    const startItem = (paging.currentPage - 1) * paging.itemsPerPage + 1;
    const endItem = Math.min(paging.currentPage * paging.itemsPerPage, paging.totalItems);

    return isLoading ? (
        <Spinner size={`re-icon-${loadingSize} re-paging-item-range`} color={'re-icon-grey'} loading={isLoading} />
    ) : paging.totalItems > 0 ? (
        <div className="re-paging-item-range">
            {format(resx(RESX_LISTINGS, 'PAGING_RANGE'), startItem, endItem, paging.totalItems)}
        </div>
    ) : null;
};

export default ItemRange;
